import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'hmt-status-popup',
  templateUrl: './status-popup.component.html',
  styleUrl: './status-popup.component.scss',
})
export class StatusPopupComponent {
  title: string;
  type: 'success' | 'error';
  iconName: string;
  config: StatusPopupConfig;

  constructor(
    private dialogRef: MatDialogRef<StatusPopupComponent>,
    @Inject(MAT_DIALOG_DATA) private data: StatusPopupData
  ) {
    this.title = data.title || 'Status Update';
    this.type = data.type || 'success';
    this.iconName = this.type === 'success' ? 'check_circle' : 'close';

    this.config = {
      isConfirmation: false,
      confirmText: 'Yes',
      cancelText: 'No',
      showCloseButton: true,
      ...data.config,
    };
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  get isConfirmation(): boolean {
    return this.config.isConfirmation || false;
  }

  get confirmText(): string {
    return this.config.confirmText || 'Yes';
  }

  get cancelText(): string {
    return this.config.cancelText || 'No';
  }

  get showCloseButton(): boolean {
    return this.config.showCloseButton !== false;
  }
}

export interface StatusPopupData {
  title: string;
  type: 'success' | 'error';
  config?: StatusPopupConfig;
}

export interface StatusPopupConfig {
  isConfirmation?: boolean;
  confirmText?: string;
  cancelText?: string;
  showCloseButton?: boolean;
}
